/*
util fn for notification popup date formatting
*/
export const formatDate = (dateString) => {
	if (!dateString) {
	  return "";
	}

	const notificationDate = new Date(dateString);
	if (isNaN(notificationDate)) {
	  return "";
	}

	const currentDate = new Date();
	const diffInMilliseconds = currentDate - notificationDate;

	const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
	const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
	const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
	const diffInWeeks = Math.floor(diffInDays / 7);

	if (diffInMinutes < 60) {
	  return `${diffInMinutes}m ago`;
	} else if (diffInHours < 24) {
	  return `${diffInHours}h ago`;
	} else if (diffInDays <= 6) {
	  return `${diffInDays}d ago`;
	} else {
	  return `${diffInWeeks}w ago`;
	}
  };
